<template>
  <v-container fluid class="usuarios-container">
    <v-data-table
      mobile-breakpoint="900"
      class="elevation-1"
      color="primary"
      :calculate-widths="true"
      :headers="tblHeaders"
      :items="usuarios"
      :search="usuarioSearch"
      :footer-props="dataTableFooterProps"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Usuarios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="usuarioSearch"
            append-icon="mdi-magnify"
            hide-details
            label="Buscar usuario"
            class="mx-4"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="newUserDialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" rounded dark class="mb-2" v-on="on"
                >+</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Agregar Usuario</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="newUserRole"
                        :items="rolesNames"
                        label="Perfil*"
                        required
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="newUserData.nombre"
                        label="Nombre*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="7">
                      <v-text-field
                        append-icon="mdi-text-short"
                        v-model="newUserData.usuario"
                        label="Usuario*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="5">
                      <v-switch
                        v-model="newUserData.estado"
                        true-value="1"
                        false-value="2"
                        label="Usuario Activo"
                        append-icon="mdi-account-check"
                        inset
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        :type="showPass ? 'text' : 'password'"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[passwordRules.required, passwordRules.min]"
                        v-model="newUserData.password"
                        @click:append="showPass = !showPass"
                        hint="Usa numeros y letras."
                        label="Contraseña*"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-file-input
                        v-model="newUserIMG"
                        color="primary accent-4"
                        counter
                        label="Foto del usuario"
                        accepted="image/png, image/jpeg"
                        prepend-icon="mdi-camera"
                        :rules="rules"
                        :show-size="1000"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            v-if="index < 2"
                            color="primary accent-4"
                            dark
                            label
                            small
                            >{{ text }}</v-chip
                          >

                          <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2"
                            >+{{ files.length - 2 }} Imagen(es)</span
                          >
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <template item.action="{ item }">
                  <v-btn color="blue darken-1" text @click="closeCreateDialog"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="saveNew()"
                    >Save</v-btn
                  >
                </template>
              </v-card-actions>
            </v-card>
            <v-snackbar
              v-model="alertAlreadyExists"
              :multi-line="true"
              absolute
            >
              Un usuario con ese nombre ya existe!

              <template v-slot:action="{ attrs }">
                <v-btn
                  color="red"
                  text
                  v-bind="attrs"
                  @click="alertAlreadyExists = false"
                >
                  Ok
                </v-btn>
              </template>
            </v-snackbar>
          </v-dialog>

          <v-dialog v-model="editUserDialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedUserData.perfil"
                        :items="rolesNames"
                        label="Perfil*"
                        outlined
                        required
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="editedUserData.nombre"
                        label="Nombre*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="7">
                      <v-text-field
                        append-icon="mdi-text-short"
                        v-model="editedUserData.usuario"
                        label="Usuario*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="5">
                      <v-switch
                        v-model="editedUserData.estado"
                        label="Usuario Activo"
                        append-icon="mdi-account-check"
                        inset
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        :type="showPass ? 'text' : 'password'"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[passwordRules.required, passwordRules.min]"
                        v-model="editedUserData.password"
                        @click:append="showPass = !showPass"
                        hint="Usa numeros y letras."
                        label="Contraseña*"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-file-input
                        v-model="newUserIMG"
                        color="primary accent-4"
                        counter
                        label="Foto del usuario"
                        accepted="image/png, image/jpeg"
                        prepend-icon="mdi-camera"
                        :rules="rules"
                        :show-size="1000"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            v-if="index < 2"
                            color="primary accent-4"
                            dark
                            label
                            small
                            >{{ text }}</v-chip
                          >

                          <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2"
                            >+{{ files.length - 2 }} Imagen(es)</span
                          >
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeEditDialog"
                  >Cancel</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveEdited()"
                  :disabled="!editedUserIsValid"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="saving" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Please stand by
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ item }">
        <span>{{
          users
            .map(function (x) {
              return x.id;
            })
            .indexOf(item.id) + 1
        }}</span>
      </template>
      <template v-slot:item.ultimo_login="{ item }">
        {{ item.ultimo_login ? item.ultimo_login : "Ningún ingreso aún" }}
      </template>
      <template v-slot:item.foto="{ item }">
        <TableRowImage :imageUrl="item.foto" />
      </template>
      <template v-slot:item.estado="{ item }">
        {{ item.estado > 0 ? "Activo" : "Inactivo" }}
      </template>
      <template v-slot:item.action="{ item }">
        <div class="usuarios__table__actions-col">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="red" small @click="deleteItem(item)"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import * as Utils from "../services/utils";
import TableRowImage from "../components/TableRowImage";

import uiMixin from "../mixins/mixin-ui";
//placed in the window object by the preload and available in the global context
// const { getImageUrl } = api.services.imagesService;
// const { saveNew, getUsuariosAll, updateUserByID, deleteUserByID } =
//   api.services.usuariosService;

export default {
  name: "Usuarios",
  mixins: [uiMixin],
  components: {
    TableRowImage,
  },
  data: function () {
    return {
      newUserAlreadyExists: false,
      newUserIMG: null,
      showPass: false,
      savingIMG: false,
      passwordRules: {
        required: (value) => !!value || "Campo obligatorio.",
        min: (v) => (v ? v.length >= 8 : false || "Minímo 8 caracteres"),
      },
      rules: [
        (value) =>
          !value || value.size < 2000000 || "La imagen debe ser menor a 2 MB!",
      ],
      perfiles: [
        "Administrador",
        "Vendedor",
        // "Especial",
      ],
      calculateWidths: true,
      usuarioSearch: "",
      editUserDialog: false,
      newUserDialog: false,
      tblHeaders: [
        {
          text: "#",
          align: "left",
          sortable: true,
          value: "id",
          width: "1%",
        },
        {
          text: "Imagen",
          align: "center",
          sortable: false,
          value: "foto",
        },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Usuario",
          align: "left",
          sortable: true,
          value: "usuario",
        },
        {
          text: "Perfil",
          align: "left",
          sortable: true,
          value: "perfil",
        },
        {
          text: "Estado",
          align: "left",
          sortable: true,
          value: "estado",
        },
        {
          text: "Ultimo Ingreso",
          align: "left",
          sortable: false,
          value: "ultimo_login",
        },
        {
          text: "Admin",
          align: "left",
          sortable: false,
          value: "action",
        },
      ],
      users: [],
      editedIndex: -1,
      editedUser: {
        nombre: "",
        usuario: "",
        password: "",
        perfil: "",
        foto: "",
        ultimo_login: "",
      },
      newUser: {
        nombre: "",
        usuario: "",
        password: "",
        perfil: "",
        estado: 0,
        foto: "",
        ultimo_login: "",
      },
      defaultItem: {},
    };
  },
  computed: {
    ...mapGetters(['demoUsers']),
    alertAlreadyExists: {
      get: function () {
        return this.newUserAlreadyExists;
      },
      set: function (userExists) {
        console.log("[userExists] ", userExists);
        this.newUserAlreadyExists = userExists;
      },
    },
    saving: {
      get: function () {
        return this.savingIMG;
      },
      set: function () {
        this.savingIMG = !this.savingIMG;
      },
    },
    newUserData: {
      get: function () {
        return this.newUser;
      },
      set: function (data) {
        this.newUser = data;
      },
    },
    editedUserData: {
      get: function () {
        return this.editedUser;
      },
      set: function (data) {
        this.editedUser = data;
      },
    },
    newUserRole: {
      get: function () {
        return this.newUser.perfil;
      },
      set: function (role) {
        this.newUser.perfil = role;
      },
    },
    newUserIsValid: {
      get: function () {
        const validName =
          this.newUser.nombre === null
            ? false
            : this.newUser.nombre === ""
            ? false
            : true;
        const validUsername =
          this.newUser.usuario === null
            ? false
            : this.newUser.usuario === ""
            ? false
            : true;
        const validRole =
          this.newUser.perfil === null
            ? false
            : this.newUser.perfil === ""
            ? false
            : true;
        const validStatus =
          this.newUser.estado === null
            ? false
            : this.newUser.estado === ""
            ? false
            : true;
        const validImage = true; //TODO: I need write a function to check that it is a valid url
        return (
          validName && validUsername && validRole && validStatus && validImage
        );
      },
      set: function () {},
    },
    editedUserIsValid: {
      get: function () {
        return true;
      },
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Editar Usuario";
    },
    usuarios: {
      get: function () {
        return this.users;
      },
      set: function (payload) {
        this.users = payload;
      },
    },
    rolesNames: {
      get: function () {
        // const roles = [];
        // this.roles.forEach((perfil) => {
        //   roles.push(perfil);
        // });

        return this.perfiles;
      },
    },
  },
  methods: {
    getImageUrl(){},
    saveNewUser(){},
    getUsuariosAll(){ return this.demoUsers; },
    updateUserByID(){},
    deleteUserByID(){},
    fetchUsers() {
      this.users = this.getUsuariosAll();
    },
    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      const editItem = Object.assign({}, item);
      editItem.password = "";
      this.editedUserData = editItem;
      // this.editedUserData = Object.assign({}, item);
      this.editUserDialog = true;
    },
    deleteItem(item) {
      const userCount = this.usuarios.length;
      const index = this.usuarios.indexOf(item);
      const { id } = item;
      console.log("[item.id]", id);

      if (userCount <= 1) {
        confirm(
          "Por favor crea otro usuario de tipo admin antes de borrar este."
        );
        return;
      }
      const confirmation =
        confirm(`Seguro quieres borrar el usuario: ${id} ${item.nombre}?`) &&
        this.usuarios.splice(index, 1);
      if (confirmation) {
        const deleted = this.deleteUserByID(id);
        console.log("[deleted] ", deleted);
      }
    },
    closeEditDialog() {
      this.editUserDialog = false;
    },
    closeCreateDialog() {
      this.newUserDialog = false;
      this.resetNewUser();
    },
    saveEdited() {
      const self = this;
      this.saving = true;
      const imgName = Utils.removeSpecialChars(this.editedUserData.nombre)
        .split(" ")
        .join("_")
        .toLowerCase();
      if (this.newUserIMG)
        this.editedUserData.getImageUrl(
          this.newUserIMG.path,
          imgName,
          "usuarios"
        );
      this.updateUserByID(this.editedUserData).then(function (info) {
        if (info) {
          self.usuarios = self.getUsuariosAll();
          self.resetEditedUser();
          self.newUserIMG = null;
          self.saving = false;
          self.closeEditDialog();
        }
      });
    },
    resetNewUser() {
      this.newUserData = {
        nombre: "",
        usuario: "",
        password: "",
        perfil: "",
        foto: "",
        ultimo_login: "",
      };
    },
    resetEditedUser() {
      this.editedUserData = {
        nombre: "",
        usuario: "",
        password: "",
        perfil: "",
        foto: "",
        ultimo_login: "",
      };
    },
    saveNew() {
      if (this.newUserIsValid) {
        const imgName = Utils.removeSpecialChars(this.newUserData.nombre)
          .split(" ")
          .join("_")
          .toLowerCase();
        if (this.newUserIMG)
          this.newUserData.foto = this.getImageUrl(
            this.newUserIMG.path,
            imgName,
            "usuarios"
          );
        const self = this;
        this.saveNewUser(this.newUserData).then(function (info) {
          if (info) {
            self.usuarios = self.getUsuariosAll();
            self.resetNewUser();
            self.newUserIMG = null;
            self.closeCreateDialog();
          } else {
            self.alertAlreadyExists = true;
          }
        });
      } else console.error("user is not valid!");
    },
  },
  mounted() {
    this.fetchUsers();
  },
};
</script>

<style scoped>
.usuarios-container {
  margin-top: 10px;
}

.usuarios__table__actions-col {
  display: flex;
  flex-wrap: nowrap;
}
</style>